import { ReactNode } from 'react';
import { MainContainer, FooterContainer } from './ServicePageTemplate';
import Footer from 'presentations/views/components/organisms/Footer';
import styled from '@emotion/styled';
import { spacing, mediaMax } from 'presentations/views/styles';

import Logo from 'presentations/views/components/atoms/Logo';
import Link from 'presentations/views/components/atoms/Link';
import Image from 'presentations/views/components/atoms/Image';
import { homePath } from 'presentations/routes/path';
import { blue02, white } from 'presentations/views/styles/color';

interface Props {
  children?: ReactNode;
}
export default function Component(props: Props) {
  return (
    <MainContainer>
      <Container>
        <Header>
          <Link href={homePath()}>
            <Logo width={130} />
          </Link>
        </Header>
        <Main>
          <Image src={`pages/error/jicoosan.svg`} alt="Jicoo" />
          {props.children}
        </Main>
      </Container>
      <FooterContainer>
        <Footer />
      </FooterContainer>
    </MainContainer>
  );
}
const Container = styled.div`
  background-color: ${blue02};
  min-height: 100vh;
`;
const Main = styled.div`
  max-width: 800px;
  padding: ${spacing(64)};
  background-color: ${white};
  margin: ${spacing(64)} auto;
  text-align: center;
  ${mediaMax.tablet} {
    width: 100%;
    margin: 0;
  }
`;

const Header = styled.div`
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 8px 20px;
  background: ${white};
`;

const Form = styled.div`
  margin: 0 auto;
`;
